import { ResetPassword } from '../components';

export function ResetPasswordPage() {
   return (
      <div className="flex justify-center">
         <ResetPassword />
      </div>
   );
}
